<template>
  <section class="firstView">
    <div :class="leadClassName">
      <Vmarket4th :is-active="vmarketActive" />
      <div class="logos">
        <a href="https://www.hikky.life/" target="_blank"
          ><img src="../../assets/logo_hikky.png" alt="VR法人HIKKY"
        /></a>
        <a href="https://virtualcast.jp/" target="_blank"
          ><img src="../../assets/logo_virtualcast.png" alt="バーチャルキャスト"
        /></a>
      </div>
    </div>
    <div class="info">
      <FxText :is-timer-trigger="true" :delay="1500" :is-liquid="true">
        <img
          src="../../assets/lead_1.svg"
          alt="アイテムのVR内購入や"
          class="liquid"
        />
      </FxText>
      <FxText :is-timer-trigger="true" :delay="1500" :is-liquid="true">
        <img
          src="../../assets/lead_2.svg"
          alt="新ギミックのVCIで遊ぼう！"
          class="liquid"
        />
      </FxText>
      <FxText :is-timer-trigger="true" :delay="1700" :is-liquid="true">
        <img
          src="../../assets/lead_day.svg"
          alt="4.29(水・祝)-5.10(日)"
          class="liquid"
        />
      </FxText>
      <FxText :is-timer-trigger="true" :delay="2500" :is-liquid="true">
        <img
          src="../../assets/lead_stage.svg"
          alt="会場：バーチャルキャスト公式スタジオ"
          class="liquid"
        />
      </FxText>
    </div>
  </section>
</template>

<script>
import Vmarket4th from "../atoms/TheVmarket4th";
import FxText from "../atoms/FxText";
export default {
  name: "FirstView",
  components: { FxText, Vmarket4th },
  props: {
    animateStep: Number
  },
  computed: {
    leadClassName: function() {
      return this.animateStep > 1 ? "lead animated" : "lead";
    },
    vmarketActive: function() {
      return this.animateStep > 2;
    }
  },
  data() {
    return {
      msg: "バーチャルキャストで"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.firstView {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5%;
  min-height: 100%;
  height: 100vh;
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
}
.lead {
  width: 50%;
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  transition: all 0.4s;
  opacity: 0.001;
  /*transform: scale(2, 2);*/
}
.lead.animated {
  opacity: 1;
  /*transform: scale(1, 1);*/
}
.logos {
  display: flex;
  width: 60%;
  padding: 20px 17.5% 20px 22.5%;
}
.logos a {
  margin: 0 2%;
}
.info {
  width: 50%;
  height: 100%;
  padding: 0 7%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  line-height: 1;
  background: url("../../assets/bg_top_date.png") no-repeat 0 0;
  background-size: 100% 100%;
}
.lead img {
  width: 100%;
}
.day {
  display: flex;
  width: 100%;
}
.day > div:nth-of-type(1) {
  padding-right: 2%;
}
.liquid {
  width: 100%;
}
@media screen and (max-width: 850px) {
  .firstView {
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
  .lead {
    width: 80%;
  }
  .info {
    width: 100%;
    height: 40vh;
    background: url("../../assets/bg_top_date_sp.png") no-repeat 0 0;
    background-size: 100% 100%;
    padding: 0 15%;
  }
}
@media screen and (max-width: 768px) {
  .info {
    padding: 0 15%;
  }
}
@media screen and (max-width: 578px) {
  .lead {
    flex-direction: column;
    align-items: center;
    padding: 0;
    width: 95%;
  }
  .logos {
    width: 90%;
    padding: 4px 0;
  }
  .info {
    padding: 1vw 10%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheFirstViewSection.vue